import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from '../../app/app-constants';

@Injectable({
  providedIn: 'root'
})
export class FilterService {

  constants: any = Constants;

  constructor(private http: HttpClient) { }

  getFilterParams() {
    return this.http.get(`${this.constants.apiMautic}/filter/params`);
  }

  getFilterCarParams() {
    return this.http.get(`${this.constants.apiMautic}/filter/vehicle`);
  }

  getUsersLista(tpPessoa, company, uf, city, tpContato, role) {
    return this.http
    .get(`${this.constants.apiMautic}/filter/search?tpPessoa=${tpPessoa}&company=${company}&uf=${uf}&city=${city}&tpContato=${tpContato}&role=${role}`);
  }

  getUsersListaCSV(tpPessoa, company, uf, city, tpContato, role) {
    return this.http
    .get(`${this.constants.apiMautic}/filter/search_csv?tpPessoa=${tpPessoa}&company=${company}&uf=${uf}&city=${city}&tpContato=${tpContato}&role=${role}`);
  }

  getCarLista(model, vehicleType, year, brand, company, userType) {
    return this.http
    .get(`${this.constants.apiMautic}/filter/search_by_car?model=${model}&vehicleType=${vehicleType}&year=${year}&brand=${brand}&company=${company}&usrType=${userType}`);
  }

  getCarListaCSV(model, vehicleType, year, brand, company, userType) {
    return this.http
    .get(`${this.constants.apiMautic}/filter/search_by_car_csv?model=${model}&vehicleType=${vehicleType}&year=${year}&brand=${brand}&company=${company}&usrType=${userType}`);
  }

  sendNotification(emails, purl, titulo, msg, plate, tp){
    return this.http
    .get(`${this.constants.apiMautic}/notice/mass/add?emails=${emails}&purl=${purl}&titulo=${titulo}&msg=${msg}&plate=${plate}&tp=${tp}`);
  }
  
  sendNotificationByPlate(purl, titulo, msg, plate, tp){
    return this.http
    .get(`${this.constants.apiMautic}/notice/mass/add?purl=${purl}&titulo=${titulo}&msg=${msg}&plate=${plate}&tp=${tp}&isVehicle=true`);
  }

}
